import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatRippleModule } from '@angular/material/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';

import { MgIconModule } from '@app/src/app/icon';
import { ScrollTargetDirectiveModule } from '@app/src/app/misc/ScrollTarget/directive';
import { NavTabsModule } from '@app/src/app/navigation/components/NavTabs';
import { SideNavTabsModule } from '@app/src/app/navigation/containers/SideNavTabs';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { FormModule } from '../form';
import { GenericModule } from '../generic';
import { ReportTableModule } from '../report-table';
import { TextModule } from '../text';
import { ManagerOverlayReportsSubpageComponent, ManagerOverlaySubpageComponent } from './components';
import { ManagerOverlayComponent } from './manager-overlay.component';

@NgModule({
  imports: [
    // Minga dependencies
    ScrollTargetDirectiveModule,
    SideNavTabsModule,
    MgIconModule,
    MgSpinnerModule,
    NavTabsModule,
    GenericModule,
    TextModule,
    FormModule,
    ReportTableModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    CdkScrollableModule,
    ScrollingModule,
    MatMenuModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatRippleModule,
  ],
  declarations: [ManagerOverlayComponent, ManagerOverlaySubpageComponent, ManagerOverlayReportsSubpageComponent],
  exports: [ManagerOverlayComponent, ManagerOverlaySubpageComponent, ManagerOverlayReportsSubpageComponent],
})
export class ManagerOverlayModule {}
